import { ResponseSource } from '@/models/thread';

export type SourceType = 'table' | 'pdf' | 'article';

export const getSourceType = (source: ResponseSource): SourceType => {
  if (source.columns && source.columns.length > 0) return 'table';
  if (source.url && source.url.includes('.pdf')) return 'pdf';
  return 'article';
};

/* Quantitative (HDX) sources carry a data sample; qualitative ones only a title and a link */
export const isQuantitativeSource = (source: ResponseSource): boolean =>
  (Array.isArray(source.sample) && source.sample.length > 0) ||
  (Array.isArray(source.columns) && source.columns.length > 0);

export const getSourceHost = (url?: string): string => {
  if (!url) return '';
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
};

/*
 * Signed S3 links carry an `Expires` timestamp. Links to HDX (used since
 * mid-October 2026) carry no query parameters and don't expire.
 */
export const isDownloadLinkExpired = (url?: string): boolean => {
  if (!url) return true;
  try {
    const expires = new URL(url).searchParams.get('Expires');
    return expires !== null && Number(expires) * 1000 < Date.now();
  } catch {
    return true;
  }
};
